import {Agent, request} from './base';
import {LocaleHint} from 'models/locale-hint';

export interface TranslateWebResult {
    created: number;
    updated: number;
}

export interface TranslateSeoResult {
    created: number;
    updated: number;
}

export class LocaleAgent {
    hints = new Agent(LocaleHint, '/locales/hints');

    translateWeb = async (params: { categoryId: number; targetLanguageId: number }): Promise<TranslateWebResult> => {
        return request.post('/locales/translate/web', params) as Promise<TranslateWebResult>;
    };

    translateSeo = async (params: {
        categoryId: number;
        appId: number;
        targetLanguageId: number;
    }): Promise<TranslateSeoResult> => {
        return request.post('/locales/translate/seo', params) as Promise<TranslateSeoResult>;
    };
}